// Mock data for the status list that would be returned by PartnerGetStatusList API endpoint
export const mockStatusList = [
  { description: 'On Hold' },
  { description: 'Pre-Coding Authorization' },
  { description: 'Void' },
  { description: 'All' },
  { description: 'Pending Review' },
  { description: 'In Progress' },
  { description: 'Completed' },
  { description: 'Rejected' }
];

// Helper function to map status filters to their internal representation
export const mapStatusFilter = statusFilter => {
  switch (statusFilter) {
    case 'On Hold':
      return 'OnHold';
    case 'Pre-Coding Authorization':
      return 'PreCodingAuthorization';
    default:
      return statusFilter;
  }
};
